import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { GRNContext } from "./Context/GRNContext";

const ProtectedRoute = () => {
  const { isAuthenticated } = useContext(GRNContext);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;